<template>
    <div>
        <FormItem label="习题名称">
            <Input v-model="name" placeholder="请输入习题名称" style="width: 300px" />
        </FormItem>
        <!-- 题型 -->
        <FormItem label="习题类型">
            <Select
                v-model="type"
                placeholder="请选择习题类型"
                @on-change="changeType"
                style="width:300px"
            >
                <Option value="1">单选</Option>
                <Option value="2">多选</Option>
                <Option value="3">看图</Option>
                <Option value="4">猜测</Option>
                <Option value="6">连线</Option>
                <Option value="7">拖拽</Option>
                <Option value="8">匹配</Option>
                <Option value="9">排序</Option>
                <Option value="10">找词语</Option>
                <Option value="11">填字母/单词</Option>
                <Option value="12">7选6</Option>
                <Option value="13">图片题</Option>
                <!-- 孙老师让注销的(已经改成视频了) -->
                <!--<Option value="5">认知题</Option>-->
            </Select>
        </FormItem>
    </div>
</template>

<script>
export default {
    data: () => ({
        name: "",
        type: "",
        themeType: ""
    }),
    watch: {
        exercise(info) {
            if (!info) {
                return;
            }
            info = JSON.parse(info);
            this.name = info.name || null;
            this.type = info.type || null;
            this.setExercise(val);
        }
    },
    methods: {
        // 修改习题类型
        changeType() {
            this.themeType = null;
        }
    }
};
</script>

<style>
</style>